import * as React from 'react'
import { useNavigate } from '../../../lib/hooks'
import ButtonSubmit from '../../share/ButtonSubmit'

export default function Button() {

  const navigateToSelectCard = useNavigate('/select-card')
  const handleOnPress = React.useCallback(() => {
    navigateToSelectCard()
  }, [navigateToSelectCard])

  return (
    <ButtonSubmit
      onPress={handleOnPress}
      disabled={false}
      text='カードを変更する'
    />
  )
}
